import { ChangeEvent } from 'react';

export function getInputOnChangeHandler<T extends string>(
  consumer: (v: T) => void
): (e: ChangeEvent<HTMLInputElement>) => void {
  return event => {
    const target = event.currentTarget;
    const value = target.value;

    consumer(value as T);
  };
}
